import { format } from 'date-fns'

export function formatNumberOnly(value){
  value = value.toString();
  //eslint-disable-next-line
  value = value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gi, '');
  value = value.replace(/(?!-)[^0-9.]/g, "");
  
  return value;
}

export function format_mask(mask, value, old_value){
  value = formatNumberOnly(value);
  old_value = formatNumberOnly(old_value);
  
  let v = value;
  let index = 0;

  if(mask){
    let nums = [];
    let num = "";
    for (let i = 0; i < mask.length; i++) {
      const c = mask[i];
      if(c==='{'){
        if(num){
          nums.push(num);
        }
        num = "";
      } else if(c==='}'){
        nums.push(parseInt(num));
        num = "";
      } else{
        num += c;
      } 
    }
    
    let format_show = "";
    let format_hidden = "";
    let format_hidden_format = "";
    nums.forEach((a)=>{
      if(Number.isInteger(a)){
        for (let i = 0; i < a; i++) {
          format_hidden += "{n}";
          format_hidden_format += "{n}";
        }
      } else {
        if(a.length>1){
          for (let i = 0; i < a.length; i++) {
            const c = a[i];
            format_hidden += `{${c}}`;
            format_hidden_format += `{${c}}`;
          }
        } else {
          format_hidden += `{${a}}`;
          format_hidden_format += `{${a}}`;
        }
      }
    })
    let aux = value?v:"";
    if(aux){
      aux = aux.toString();
      
      for (let i = 0; i < aux.length; i++) {
        let n = aux[i];
        format_hidden_format = format_hidden_format.replace("{n}",`{${n}}`);   
      }
      let start_index = 0;
      
      for (let i = 0; i < format_hidden.length; i+=3) {
        let num = `${format_hidden_format[i]}${format_hidden_format[i+1]}${format_hidden_format[i+2]}`;
        if(num === "{n}"){
          format_show += "_";
          if(index === 0){
            index = (i/3);
            let i_aux = i-3;
            if(i_aux>=0){
              let aux = `${format_hidden[i_aux]}${format_hidden[i_aux+1]}${format_hidden[i_aux+2]}`;
              while(aux !== "{n}"){
                index-=1;
                i_aux = i_aux-3;
                aux = `${format_hidden[i_aux]}${format_hidden[i_aux+1]}${format_hidden[i_aux+2]}`;
              }
              i_aux = i-6;
              if(i_aux >= 0){
                aux = `${format_hidden[i_aux]}${format_hidden[i_aux+1]}${format_hidden[i_aux+2]}`;
                if(aux !== "{n}" && value.length > old_value.length){
                  start_index+=1;
                  index+=1;
                }
              }
            }
          }
        } else {
          format_show += num.replace("{","").replace("}","");
        }
      }
      if(format_hidden.length>0 && index === 0){
        index = format_hidden.length/3;
      }
      return {value:format_show, index:index, start_index:start_index};
      // return format_show;
    }
  }
  return {value:value?v:"", index:value.length, start_index:0};
}

export function stod(date_string){
  try {
    let aux = date_string.split(" ");
    aux = aux[0].split("-");
    let d = new Date();
    let {year, month, day} = {year:d.getFullYear(), month:d.getMonth(), day:d.getDate()};
    if(aux.length > 0){
      year = parseInt(aux[0]);
      if(aux.length>1){
        month = parseInt(aux[1])-1;
        if(aux.length>2){
          day = parseInt(aux[2]);
        }
      }
    }
    let date = new Date(year,month,day);
    if(date.getDate()){
      return date;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

export function dtos(date, format_s = "yyyy-MM-dd"){
  try {
    return format(date, format_s);
  } catch (error) {
    return "";
  }
}

export function format_size_byte(byte){
  let prefix = ["B","KB","MB","GB","TB"]
  let i_prefix = 0;
  let aux_byte = byte;

  while(aux_byte >= 1024){
    i_prefix+=1;
    aux_byte = aux_byte/1024;
  }
  
  return `${aux_byte.toFixed(1)} ${prefix[i_prefix]}`;
}

export function get_byte(value, prefix){
  let p = ["B","KB","MB","GB","TB"]
  let v = value;
  for (let i = p.indexOf(prefix); i > 0; i--) {
    v = v * 1024;
  }

  return v;
}
